export default __webpack_public_path__ + "static/media/Linkedin.b0f100d2.svg";